(function (window) {
  'use strict';

  function handleColorSwitch(e) {
    const color = e.target.closest('.js-lens-colors-color');
    const instance = color.closest('.js-lens-colors');
    const currentExpandedColorButton = instance.querySelector('.js-lens-colors-color-toggle[aria-expanded="true"]');
    const currentVisibleLensComparison = instance.querySelector('.lens-colors__comparison[aria-hidden="false"]');

    if (e.target.classList.contains('js-lens-colors-color-toggle') && e.target.getAttribute('aria-expanded') === 'false') {
      currentExpandedColorButton.setAttribute('aria-expanded', false);
      currentVisibleLensComparison.setAttribute('aria-hidden', true);
      // Set current target aria's.
      e.target.setAttribute('aria-expanded', true);
      e.target.parentNode.querySelector('.lens-colors__comparison')
        .setAttribute('aria-hidden', false);
    }
  }

  function handleCarouselTransition(info) {
    const colors = info.container.querySelectorAll('.js-lens-colors-color');

    // Ensures the page being switched to has the active color.
    if (colors.length > info.index) {
      const toggle = colors[info.index].querySelector('.js-lens-colors-color-toggle');

      toggle.click();
    }
  }

  function initCarousel(instance) {
    const carousel = instance.querySelector('.js-lens-colors-carousel');

    return imagesLoaded(carousel, function () {
      tns({
        container: carousel,
        controlsContainer: carousel.parentNode.querySelector('.js-lens-colors-controls'),
        items: 1,
        responsive: {
          681: 2,
          1025: 4
        },
        slideBy: 'page',
        nav: false,
        loop: false,
        touch: false,
        onInit: () => {
          const prevNextControls = instance.querySelectorAll('.lens-colors__color-control');
          for(let i = 0; i < prevNextControls.length; i++) {
            prevNextControls[i].setAttribute('tabindex', 0);
          }
        }
      }).events.on('transitionStart', handleCarouselTransition);
    });
  }

  function initColorSwitch(instance) {
    const colorToggles = instance.querySelectorAll('.js-lens-colors-color-toggle');

    for (let i = 0; i < colorToggles.length; i++) {
      colorToggles[i].addEventListener('click', handleColorSwitch);
    }
  }

  function init() {
    const instances = document.querySelectorAll('.js-lens-colors');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-component-init')) {
        initCarousel(instances[i]);
        initColorSwitch(instances[i]);

        instances[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
